import { clsx } from 'clsx';
import { forwardRef } from 'react';

import type { ButtonHTMLAttributes, ReactNode } from 'react';
import type { UIButtonVariant } from 'types/UserInterface';

import styles from './Button.module.css';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'style'> {
  /** The variant of the button. */
  variant: UIButtonVariant;
  /** The element to show inside the button. */
  children: ReactNode;
  /** Renders the button as a flex column. */
  displayColumn?: boolean;
}

/** Represents a component for a button. */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, type = 'button', variant, displayColumn = false, ...restProps }: ButtonProps, forwardedRef) => {
    return (
      <button
        {...restProps}
        type={type}
        ref={forwardedRef}
        className={clsx(styles['button'], styles[`button--${variant}`], {
          [styles['button--wide-column']]: displayColumn,
        })}
      >
        {children}
      </button>
    );
  }
);
